import { RealEstateChangesDocument } from "@onpreo/database";

export type RealEstateChangesState = { guestRealEstatesChanges: RealEstateChangesDocument[]; active: number };
export const initialRealEstateChangesState = {
    guestRealEstatesChanges: [] as RealEstateChangesState["guestRealEstatesChanges"],
    active: 0
};
